<template>
  <v-row justify="center">
    <v-dialog v-model="active" :persistent="fix" max-width="400">
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon v-if="!fix" size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          {{title}}
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; min-height:80px; font-size:15px">
          {{content}}
        </v-card-text>
        <v-row justify="center">
          <v-card-actions>
            <v-btn outlined color="#FFF" style="width: 150px; height:46px; border-radius: 10px; background:#7AC7FC"
            @click="save">
              確定
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'ShowMsg',
    props:['onSave'],
    data () {
      return {
        active: false,
        title: '',
        content: '',
        onSaveEn: false,
        fix: false,
        info: '',
      }
    },
    methods:{
      open(type = null, title = null, content = null, onSaveEn = false, fix = false, info = null){
        this.active = true
        this.onSaveEn = onSaveEn
        this.fix = fix
        this.info = info

        switch(type){
          case 0:
          default:
            this.title = title
            this.content = content
            break
          case 1:
            this.title = '請輸入所有必填'
            this.content = '請輸入所有必填。'
            break
          case 2:
            this.title = '已新增資料'
            this.content = '系統已新增此筆資料'
            break
          case 3:
            this.title = '已修改資料'
            this.content = '系統已修改此筆資料'
            break
          case 4:
            this.title = '已刪除資料'
            this.content = '系統已刪除此筆資料。*系統將無法再查詢到相關資料'
            break
          case 5:
            this.title = '時間錯誤'
            this.content = '開始時間不能大於結束時間'
            break
          case 6:
            this.title = '儲存成功'
            this.content = '系統已成功儲存資料'
            break
          case 7:
            this.title = '已建立薪資'
            this.content = '系統已建立該月份薪資資訊'
            break
          //seldom use
          case 9:
            this.title = '送出成功'
            this.content = '當月堂數設定送出成功。'
            break
          case 10:
            this.title = '返回上一步'
            this.content = '已返回薪資計算步驟，確認資料無誤後，請再次點擊「計算完成送出」。'
            break
          case 11:
            this.title = '薪資計算完成'
            this.content = '薪資已計算完成，請進行覆核。如需調整，請點擊「返回上一步」。'
            break
          case 12:
            this.title = '覆核完成送出'
            this.content = '薪資已完成覆核，可匯出轉帳Excel。完成確認後請點擊「封存」，封存後教職員即可查看。'
            break
          case 13:
            this.title = '封存完成送出'
            this.content = '薪資已完成封存。如需查詢歷史資料，請至「薪資作業管理 > 歷史薪資查詢」查看。'
            break
            
          case 15:
            this.title = '系統提示'
            this.content = '點儲存後才允許其他筆資料進行編輯'
            break
          case 20:
            this.title = '新密碼長度不符'
            this.content = '請確認"新密碼"為4~10個英文字母或數字。'
            break
          case 21:
            this.title = '兩組新密碼不同'
            this.content = '請確認"新密碼"和"確認新密碼"相同。'
            break
          case 22:
            this.title = '舊密碼輸入錯誤'
            this.content = '請確認您的"舊密碼"。'
            break
          case 23:
            this.title = '已修改密碼'
            this.content = '系統已修改您的密碼，請重新登入'
            break
          case 24:
            this.title = '已還原密碼'
            this.content = '系統已還原密碼，請使用預設密碼(員工編號)登入'
            break
          case 30:
            this.title = '已移除'
            this.content = '系統已移除該教師當月堂數資訊'
            break
        }
      },
      close(){
        this.active = false
      },
      save(){
        if(this.onSaveEn){
          this.onSave(this.info)
        }
        this.close()
      }
    }
  }
</script>